module.exports = __webpack_public_path__ + "assets/615d9b799e81e6e5d0f507eb2ef7f9b9.png";